module.exports = __webpack_public_path__ + "img/1440.75b4cc53.jpg";